export default "__VITE_ASSET__Sd7iXFi1__"